import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a2b2f734")

_pushScopeId("data-v-a2b2f734")
const _hoisted_1 = { class: "p-component" }
const _hoisted_2 = { class: "p-timepicker" }
const _hoisted_3 = { class: "p-hour-picker" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "pi pi-chevron-up" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "pi pi-chevron-down" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ElPopover = _resolveComponent("ElPopover")

  return (_openBlock(), _createBlock(_component_ElPopover, {
    disabled: _ctx.disabled,
    "popper-class": "el-dropdown__popper el-dropdown--context"
  }, {
    reference: _withId(() => [
      _createVNode("span", {
        class: ["p-calendar p-component p-inputwrapper p-calendar-w-btn p-inputwrapper-filled", _ctx.width]
      }, [
        _createVNode("input", {
          class: ["p-inputtext p-component", {'input-error': _ctx.inputError}],
          type: "text",
          disabled: _ctx.disabled,
          readonly: "",
          inputmode: "none",
          value: _ctx.textToShow
        }, null, 10, ["disabled", "value"]),
        _createVNode("button", {
          class: "p-button p-component p-button-icon-only p-datepicker-trigger",
          disabled: _ctx.disabled,
          tabindex: -1,
          type: "button"
        }, [
          _createVNode("span", {
            class: ["p-button-icon", _ctx.icon]
          }, null, 2)
        ], 8, ["disabled"])
      ], 2)
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("button", {
              class: "p-link",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addHour && _ctx.addHour(...args)))
            }, [
              _hoisted_4
            ]),
            _createVNode("span", null, _toDisplayString(_ctx.textToShow), 1),
            _createVNode("button", {
              class: "p-link",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeHour && _ctx.removeHour(...args)))
            }, [
              _hoisted_5
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["disabled"]))
})